module.exports = __webpack_public_path__ + "img/field_goal_left.46c3e91e.jpg";